const moduleRoutes = [
    {
        path: '/product',
        name: 'products',
        children: [
            {
                path: '',
                name: 'productList',
                component: () => import('@/modules/product/list/List.vue'),
                meta: {
                    resource: 'products',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'Products',
                    breadcrumbs: [{ title: 'Product List', routeName: 'productList' }]
                }
            },
            {
                path: 'new',
                name: 'productNew',
                component: () => import('@/modules/product/entry/New.vue'),
                meta: {
                    resource: 'products',
                    action: 'create',
                    layout: 'default',
                    auth: true,
                    title: 'New Product',
                    breadcrumbs: [
                        { title: 'Product List', routeName: 'productList' },
                        { title: 'New', routeName: 'productNew' }
                    ]
                }
            },
            {
                path: ':id/edit',
                name: 'productEdit',
                component: () => import('@/modules/product/entry/Edit.vue'),
                meta: {
                    resource: 'products',
                    action: 'edit',
                    layout: 'default',
                    auth: true,
                    title: 'Edit Product',
                    breadcrumbs: [
                        { title: 'Product List', routeName: 'productList' },
                        { title: 'Edit', routeName: 'productEdit' }
                    ]
                }
            }
        ]
    }
]

export default moduleRoutes
